import { create } from "zustand";
import { API_BASE_URL1 } from "../../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../../utils/apiCall";
import { toast } from "react-toastify";

const TippingFeeCalculationStore = create((set, get) => ({
    tippingFeeReportData: [],
    tippingFeeInnerZoneReportData: [],
    ieNameList: [],
    loading: false,
    error: null,

    // ================= MAIN REPORT =================
    fetchTippingFeeCalculationReport: async (queryParams) => {
        set({ loading: true, error: null });

        const queryString = new URLSearchParams(queryParams).toString();

        try {
            const tippingDataReport = await apiCall({
                url: `${API_BASE_URL1}KpiReport/TippingFeeCalculationReport?${queryString}`,
                method: "get",
                token: localStorage.getItem("token"),
            });

            set({
                tippingFeeReportData: Array.isArray(tippingDataReport)
                    ? tippingDataReport
                    : [],
                loading: false,
                error: null
            });

        } catch (error) {

            const status = error.response?.status;
            const message = error.response?.data?.message;

            // ✅ 500 Internal Server Error
            if (status === 500) {
                toast.error("Internal Server Error");
                set({
                    tippingFeeReportData: [],
                    error: "Internal Server Error",
                    loading: false
                });

            }
            // ✅ 404 No Data
            else if (status === 404) {
                toast.error(error.message);
                set({
                    tippingFeeReportData: [],
                    error: "No Data found.",
                    loading: false
                });
            }
            // ✅ Other Errors
            else {
                toast.error(message || "Something went wrong");
                set({
                    tippingFeeReportData: [],
                    error: message || "Something went wrong",
                    loading: false
                });
            }

        } finally {
            set({ loading: false });
        }
    },

    // ================= INNER ZONE REPORT =================
    fetchTippingFeeCalculationInnerZoneReport: async (queryParams) => {
        set({ loading: true, error: null });

        const queryString = new URLSearchParams(queryParams).toString();
       
        try {
            const tippingDataInnerReport = await apiCall({
                url: `${API_BASE_URL1}KpiReport/TippingFeeCalculationSummary?${queryString}`,
                method: "get",
                token: localStorage.getItem("token"),
            });

            set({
                tippingFeeInnerZoneReportData: Array.isArray(tippingDataInnerReport)
                    ? tippingDataInnerReport
                    : [],
                loading: false,
                error: null
            });

        } catch (error) {

            const status = error.response?.status;
            const message = error.response?.data?.message;
            // ✅ 500 Internal Server Error
            if (status === 500) {
                toast.error("Internal Server Error");
                set({
                    tippingFeeInnerZoneReportData: [],
                    error: "Internal Server Error",
                    loading: false
                });

            }
            // ✅ 404 No Data
            else if (status === 404) {
                toast.error(error.message);
                set({
                    tippingFeeInnerZoneReportData: [],
                    error: "No Data found.",
                    loading: false
                });
            }
            // ✅ Other Errors
            else {
                toast.error(message || "Something went wrong");
                set({
                    tippingFeeInnerZoneReportData: [],
                    error: message || "Something went wrong",
                    loading: false
                });
            }

        } finally {
            set({ loading: false });
        }
    },

}));

export default TippingFeeCalculationStore;
